export enum ErrorCode {
  // Api
  SSOTokenNotExist = 'B4301',
  SSOTokenInactive = 'B4302',
  MobilePhoneIsNotDefined = 'B4303',
  ClientNotExistWithSession = 'B4304',
  SiebelIdIsNotDefined = 'B4305',
  UserIsNotResident = 'B4308',
  ClientHasNotSSO_ID = 'B4311',
  InvalidAge = 'B4406',
  InvalidCitizenship = 'B5326',
  UserBanned = 'B4309',
  SessionExpired = 'B4310',
  TaskIsNotExist = 'B4312',
  DailyGameNotExist = 'B4316',
  DailyGameAlreadyCompleted = 'B4319',
  ProductLoyalties = 'B4307',
  ErrorRequestDB = 'B5301',
  InvalidTransactionTypeDuringQueries = 'B5302',
  UnknownClusterKafka = 'B5303',
  KafkaConsumerAlreadyRunning = 'B5304',
  KafkaMessageNotMatchesContract = 'B5305',
  ExtractToken = 'B5306',
  KafkaMessageSend = 'B5308',
  KafkaConnection = 'B5309',
  InvalidParametersRequestToDB = 'B5310',
  UnknownClusterKafkaConsumer = 'B5311',
  ClientDuplicated = 'B5312',
  RequestWithoutTransaction = 'B5313',
  SettingsNotMatchScheme = 'B5314',
  InitKeyDB = 'B5315',
  QueryToCacheTimeoutExpired = 'B5316',
  QueriesAndTransactionsUses = 'B5317',
  ParallelRequestsForTaskProgressChanges = 'B5318',
  DataInQueueNotMatchQueueType = 'B5319',
  DecodingProtobufMessage = 'B5320',
  EncodingProtobufMessage = 'B5321',
  LoadProtobufScheme = 'B5322',
  DuplicatedBrokerAccount = 'B5325',
  TaskProcessCompleted = 'B5324',
  InvitedFriendInTheGame = 'B4314',
  InvitedFriendInvalidRefId = 'B4315',
  RecalculationLeagues = 'B4334',
  RateLimiting = 'B5336',
  TooManyRequests = 'B429',
  GameIsNotAProgress = 'B4325',

  InternalServer = 'B5001',
  QueryFailed = 'B5002',
  GetProductLoyaltiesV2 = 'B5307',
  // Client
  TestError = 'F9999',
  UnmatchedError = 'F2001',
  BoundaryError = 'F2002',
  EconnAborted = 'F2003',
  // Неизвестная ошибка
  UnknownError = 'U0001',
}

// TODO: https://jira.tcsbank.ru/browse/SP-18532
export enum ErrorAction {
  LogoutWithReload = 'LogoutWithReload',
  LogoutWithRedirectToMainForm = 'LogoutWithRedirectToMainForm',
  Logout = 'Logout',
  Reload = 'Reload',
  AuthReloadWithoutQueryRef = 'AuthReloadWithoutQueryRef',
  CloseClickerModal = 'CloseClickerModal',
}

export const ERROR_BOUNDARY_MESSAGE = 'Something went wrong in app';
